var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplylogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.899055C0 0.402521 0.402521 0 0.899055 0H24.8739C25.3704 0 25.7729 0.402521 25.7729 0.899055V9.8896C25.7729 10.3861 25.3704 10.7887 24.8739 10.7887C24.3773 10.7887 23.9748 10.3861 23.9748 9.8896V1.79811H1.79811V17.9811H12.8865C13.383 17.9811 13.7855 18.3836 13.7855 18.8802C13.7855 19.3767 13.383 19.7792 12.8865 19.7792H0.899055C0.402521 19.7792 0 19.3767 0 18.8802V0.899055Z",
    fill: "#9AA4B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.179864 0.359675C0.477785 -0.0375526 1.04131 -0.118057 1.43854 0.179864L12.8865 8.76584L24.3345 0.179864C24.7317 -0.118057 25.2952 -0.0375526 25.5931 0.359675C25.8911 0.756902 25.8106 1.32043 25.4133 1.61835L13.4259 10.6089C13.1063 10.8486 12.6667 10.8486 12.3471 10.6089L0.359675 1.61835C-0.0375526 1.32043 -0.118057 0.756902 0.179864 0.359675Z",
    fill: "#9AA4B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7354 22.9999C18.6814 22.9999 16.2028 20.5323 16.2028 17.4672C16.2028 14.4021 18.6814 11.9346 21.7354 11.9346C24.8005 11.9346 27.2681 14.4132 27.2681 17.4672C27.2681 20.5212 24.7894 22.9999 21.7354 22.9999ZM25.1615 16.9504C23.4132 15.6279 20.968 15.6718 19.2579 17.0622V16.2288C19.2579 15.8691 18.9596 15.5708 18.5999 15.5708C18.2402 15.5708 17.9419 15.8691 17.9419 16.2288V18.5712C17.9419 18.9309 18.2402 19.2292 18.5999 19.2292H20.9424C21.3021 19.2292 21.6003 18.9309 21.6003 18.5712C21.6003 18.2115 21.3021 17.9132 20.9424 17.9132H20.2844C21.4669 17.0893 23.0408 17.0814 24.2274 17.8895C24.5267 18.0934 24.9397 18.0988 25.1946 17.8414C25.4482 17.5854 25.449 17.1679 25.1615 16.9504Z",
    fill: "#9AA4B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplylogo);
export default __webpack_public_path__ + "static/media/reply logo.a44856d981d5bac2973fcadfd315a279.svg";
export { ForwardRef as ReactComponent };